<script>
import simplebar from "simplebar-vue";
import i18n from "@/i18n";
import { mapState } from "vuex";
import DeviceDetectionMixin from "@/mixins/DeviceDetectionMixin";

/**
 * Topbar component
 */
export default {
  props: {
    type: {
      type: String,
      required: true,
    },
    layoutscroll: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [ DeviceDetectionMixin ],
  computed: mapState({
    currentUser: state => state.auth.user,
    pageTitle () {
      return this.$route.meta(this.$route).title || ''
    },
    overwritePageTitle: state => state.layout.overwritePageTitle,
  }),
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/images/flags/germany.jpg"),
          language: "de",
          title: "German",
        },
        {
          flag: require("@/assets/images/flags/italy.jpg"),
          language: "it",
          title: "Italian",
        },
        {
          flag: require("@/assets/images/flags/russia.jpg"),
          language: "ru",
          title: "Russian",
        },
        {
          flag: require("@/assets/images/flags/japan.jpg"),
          language: "ja",
          title: "Japan",
        },
      ],
      lan: i18n.locale,
      text: null,
      flag: null,
      value: null,
      isSaml: process.env.VUE_APP_IS_USE_SAML_AUTH === 'true',
    };
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
  },
  methods: {
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    setLanguage(locale, country, flag) {
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    async handleLogout() {
      this.$store.dispatch("auth/logout");

      if (process.env.VUE_APP_IS_USE_SAML_AUTH === 'true') {
        // 実行環境の場合
        const redirectUrl = await this.$store.dispatch("auth/logout");
        // API からシングルログアウト用の URL が返却されるが、GMOトラストログイン側で対応していないので利用できない
        // window.location.href = redirectUrl;

        // 暫定的に GMO トラストログインに飛ばす
        window.location.href = process.env.VUE_APP_GMO_PORTAL_URL;
      } else {
         // ローカルの場合はシステムのログイン画面に遷移
         this.$router.push({ name: "login" });
      }
    },
  },
  components: { simplebar },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case "dark":
              document.body.setAttribute("data-topbar", "dark");
              break;
            case "light":
              document.body.setAttribute("data-topbar", "light");
              document.body.removeAttribute("data-layout-size", "boxed");
              break;
            default:
              document.body.setAttribute("data-topbar", "dark");
              break;
          }
        }
      },
    },
    layoutscroll: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case false:
              document.body.setAttribute("data-layout-scrollable", "false");
              break;
            case true:
              document.body.setAttribute("data-layout-scrollable", "true");
              break;
            default:
              document.body.setAttribute("data-layout-scrollable", "false");
              break;
          }
        }
      },
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/SeiwaEv-logo-icon.png" alt="" style="width:100%;"/>
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/SeiwaEv-logo-icon.png" alt="" style="width:100%;"/>
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/SeiwaEv-logo-icon.png" alt="" style="width:40px;"/>
            </span>
            <span class="logo-lg">
              <img v-if="!this.$parent.isMenuCondensed" src="@/assets/images/SeiwaEv-logo.png" alt="" style="width:100%;"/>
              <img v-if="this.$parent.isMenuCondensed" src="@/assets/images/SeiwaEv-logo-icon.png" alt="" style="width:40px;"/>
            </span>
          </router-link>
        </div>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 vertinav-toggle header-item waves-effect"
          id="vertical-menu-btn"
          @click="toggleMenu()"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
        <template v-if="!this.detectMobileDevice()">
          <div class="page-title d-flex align-self-end" v-if="overwritePageTitle" v-html="overwritePageTitle"></div>
          <div class="page-title" v-else>{{pageTitle}}</div>
        </template>
        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 horinav-toggle header-item waves-effect waves-light"
          data-bs-toggle="collapse"
          data-bs-target="#topnav-menu-content"
          @click="toggleMenu()"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

      </div>

      <div class="d-flex">


        <b-dropdown
          class="d-inline-block"
          menu-class="dropdown-menu-end"
          variant="white"
          toggle-class="header-item"
        >
          <template #button-content>
            <span class="d-xl-inline-block ms-1">{{
                currentUser ? currentUser.user_name : ''
            }}</span>
            <i class="mdi mdi-chevron-down d-xl-inline-block"></i>
          </template>
          <a class="dropdown-item cursor-pointer" @click="handleLogout" v-if="isSaml"
            ><i
              class="mdi mdi-logout text-muted font-size-16 align-middle me-1"
            ></i>
            <span class="align-middle" key="t-logout">{{
                $t("common.navbar.dropdown.logoutIdP")
            }}</span></a
          >
          <a class="dropdown-item cursor-pointer" @click="handleLogout" v-else
            ><i
              class="mdi mdi-logout text-muted font-size-16 align-middle me-1"
            ></i>
            <span class="align-middle" key="t-logout">{{
                $t("common.navbar.dropdown.logout")
            }}</span></a
          >
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
<style lang="scss">
.system-name {
  color: #ffffff;
  cursor: pointer;
}
.page-title {
  align-self: center;
  font-size: 20px;
  font-weight: 600;
}
</style>
